import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken, rgba } from 'polished';

enum ItemType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY',
}

export interface Props {
  title: any;
  type?: ItemType;
  theme?: any;
  hoverItems?: any;
  onClick?: any;
  url?: string;
}

function NavigationItem({ title, type, url, theme, onClick }: Props) {
  const loadColorBasedOnItemType = () => {
    switch (type) {
      case ItemType.PRIMARY: {
        return theme.colors.white;
      }
      case ItemType.SECONDARY: {
        return theme.colors.primary;
      }
      case ItemType.TERTIARY: {
        return theme.colors.textPrimary;
      }
      default: {
        return theme.colors.white;
      }
    }
  };

  const loadBackgroundColorBasedOnItemType = () => {
    switch (type) {
      case ItemType.PRIMARY: {
        return theme.colors.primary;
      }
      case ItemType.SECONDARY: {
        return 'transparent';
      }
      case ItemType.TERTIARY: {
        return 'transparent';
      }
      default: {
        return theme.colors.primary;
      }
    }
  };

  const loadFontWeightBasedOnItemType = () => {
    switch (type) {
      case ItemType.PRIMARY: {
        return 400;
      }
      case ItemType.SECONDARY: {
        return 400;
      }
      case ItemType.TERTIARY: {
        return 300;
      }
      default: {
        return 400;
      }
    }
  };

  const loadDisplayBasedOnItemType = () => {
    switch (type) {
      case ItemType.PRIMARY: {
        return 'inline-block';
      }
      case ItemType.SECONDARY: {
        return 'flex';
      }
      case ItemType.TERTIARY: {
        return 'flex';
      }
      default: {
        return 'inline-block';
      }
    }
  };

  const color = loadColorBasedOnItemType();
  const bgColor = loadBackgroundColorBasedOnItemType();
  const fontWeight = loadFontWeightBasedOnItemType();
  const display = loadDisplayBasedOnItemType();

  return (
    <Wrapper
      to={url || ''}
      display={display}
      fontWeight={fontWeight}
      color={color}
      bgColor={bgColor}
      onClick={onClick}
      type={type}
    >
      {title}
    </Wrapper>
  );
}

interface WrapperProps {
  color: any;
  bgColor: any;
  fontWeight: any;
  display: string;
  type: string;
  theme: any;
}

const Wrapper = styled(Link)`
  text-decoration: none;
  /* padding: ${rem(19)} ${rem(16)}; */
  color: ${({ color }: WrapperProps) => color};
  background-color: ${({ bgColor }: WrapperProps) => bgColor};
  font-weight: ${({ fontWeight }: WrapperProps) => fontWeight};
  line-height: ${rem(22)};
  font-size: ${rem(14)};
  height: ${rem(62)};
  display: ${({ display }: WrapperProps) => display};
  align-items: flex-end;
  position: relative;
  transition: all 0.2s ease;
padding: ${rem(19)} ${rem(16)};

&:first-child {
  padding: ${({ type }: WrapperProps) =>
    type === ItemType.TERTIARY
      ? `${rem(19)} ${rem(16)} ${rem(19)} ${rem(32)}`
      : type === ItemType.PRIMARY
      ? `${rem(19)} ${rem(32)}`
      : `${rem(19)} ${rem(16)}`};
    }

  &:hover {
    text-decoration: ${({ type }: WrapperProps) =>
      type === ItemType.TERTIARY ? 'underline' : 'none'};
    background-color: ${({ type, theme, bgColor }: WrapperProps) =>
      type === ItemType.SECONDARY
        ? darken(0.1, rgba(49, 39, 131, 0.04))
        : type === ItemType.PRIMARY
        ? darken(0.1, theme.colors.primary)
        : bgColor};
  }
`;

function areEqual(prev: Props, next: Props) {
  return prev.url === next.url && prev.title === next.title;
}
const withThemeNavigationItem: any = React.memo(
  withTheme(NavigationItem),
  areEqual,
);
export { withThemeNavigationItem as NavigationItem, ItemType };
